import React from 'react';
import SplashScreen from '../SplashScreen';

const LoadingPage = ({ message = 'Carregando...' }) => {
  return <SplashScreen message={message} />;
};

export default LoadingPage;
